import axios from "axios";
import { get, post, remove, put } from "../api_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;
const token = sessionStorage.getItem("jwt_access_token");

//Post
export const deleteActionGg1 = (ID) =>
  remove(`${baseURL}/GG1Common/${ID?.ActionNo}?IsCancel=${ID?.isCancel}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

export const checkEmployeeMasterApiCall = async (id) =>
  // await get(baseURL + "/Employee/CheckForEmployeeMasterByEmployeeId/" + id, {
    await get(baseURL + "/Employee/CheckForEmployeeMasterByEmployeeIdOrSSN/" + id, {
    headers: {
      "Content-type": "application/json",
      "x-access-token": token,
    },
  })
    .then((res) => res)
    .catch((error) => error);

export const GetPositionSalaryByGradeApiCall = async (id) =>
  await get(
    baseURL +
      "/GG1Common/GetPositionSalaryByGrade/" +
      id?.range_next?.trim() +
      "/" +
      id?.label,

    {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => res)
    .catch((error) => error);

// AddGG1EmployeeMaster

export const AddGG1EmployeeMasterApiCall = async (id) =>
  await post(baseURL + "/Employee/AddGG1EmployeeMaster", id, {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res)
    .catch((error) => error);
